import * as React from "react";
import { H2, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
const NoRangesConfigured = () => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(H2, { variant: "heading-smallest" }, getLabel("products.contactLenses.prescription.title")), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, getLabel("common.errors.nonrecoverable.generic"))));
};
export {
  NoRangesConfigured
};
//# sourceMappingURL=NoRangesConfigured.js.map
